export default __webpack_public_path__ + "static/media/daily-check-in-bg.1548a9a7.webp";